'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Contacts = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Contacts, _Component);

  function Contacts() {
    (0, _classCallCheck3.default)(this, Contacts);
    return (0, _possibleConstructorReturn3.default)(this, (Contacts.__proto__ || (0, _getPrototypeOf2.default)(Contacts)).apply(this, arguments));
  }

  (0, _createClass3.default)(Contacts, [{
    key: 'render',
    value: function render() {
      var styles = require(this.props.mobile ? './IntroMobile.scss' : './Intro.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.intro, style: this.props.customStyle },
        _react2.default.createElement(
          'div',
          { className: styles.title, style: this.props.customTitleStyle },
          'Th\xF4ng tin li\xEAn h\u1EC7'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.introSection, style: this.props.customStyle },
          _react2.default.createElement(
            'p',
            null,
            'C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u0110\u1ECBa ch\u1EC9: 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, TP H\u1ED3 Ch\xED Minh'
          ),
          _react2.default.createElement(
            'p',
            null,
            'S\u1ED1 gi\u1EA5y ph\xE9p \u0110KKD 0315074848 do s\u1EDF K\u1EBF ho\u1EA1ch v\xE0 \u0110\u1EA7u T\u01B0 TPHCM c\u1EA5p ng\xE0y 28/05/2018'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Email: hr@lookme.vn'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Phone: 0933 207 298'
          )
        )
      );
    }
  }]);
  return Contacts;
}(_react.Component), _class.propTypes = {
  customTitleStyle: _react.PropTypes.any,
  customStyle: _react.PropTypes.any,
  mobile: _react.PropTypes.bool
}, _temp);
exports.default = Contacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/Contacts.js
// module id = 1651
// module chunks = 0